// extracted by mini-css-extract-plugin
export default {"root":"zjjk7FSSFa9mbXQJWdBU","iconActive":"r6FziYsw6akdLWccnysz","titleActive":"RooRRO7le63GbQvfVmqP","title":"UrrcJzSninLM6iX2FNlq","placeHolderShimmer":"X0xHwqLgr0Chfm1xL2pQ"};